// extracted by mini-css-extract-plugin
module.exports = {"label":"switch-module__label___wZ34x","input":"switch-module__input___RTlQp","switch":"switch-module__switch___7gkzV","toggle":"switch-module__toggle___FPVVF"};